(function () {
  var root = document.querySelector('[data-pz-root]');
  if (!root) return;

  function wrapEvery15(text) {
    var words = text.split(' ');
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      if (current === '') {
        current = word;
      } else if (lines.length >= 2) {
        current += ' ' + word;
      } else if ((current + ' ' + word).length <= 15) {
        current += ' ' + word;
      } else {
        lines.push(current);
        current = word;
      }
    });
    if (current) lines.push(current);
    return lines.join('\n');
  }


  var trigger = document.querySelector('[data-pz-trigger]');
  var overlay = document.querySelector('[data-pz-overlay]');
  var closeBtn = root.querySelector('[data-pz-close]');

  document.body.appendChild(overlay);
  document.body.appendChild(root);

  var lockedScrollY = 0;

  function openDrawer() {
    lockedScrollY = window.scrollY;
    root.style.visibility = 'visible';
    root.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.position = 'fixed';
    document.body.style.top = -lockedScrollY + 'px';
    document.body.style.width = '100%';
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, lockedScrollY);
    setTimeout(function () {
      root.style.visibility = 'hidden';
    }, 250);
  }

  trigger.addEventListener('click', openDrawer);
  closeBtn.addEventListener('click', closeDrawer);
  overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  var state = {
    mainVariantId: root.dataset.mainVariantId,
    basePrice: parseFloat(root.dataset.basePrice),
    angelFont: 'Classic',
    extraEngrave: false,
    extraFont: 'Classic',
    priority: false,
    review: true,
    note: false
  };

  var addons = {
    extraEngrave: { id: root.dataset.extraEngraveVariantId, price: parseFloat(root.dataset.extraEngravePrice) },
    priority: { id: root.dataset.priorityVariantId, price: parseFloat(root.dataset.priorityPrice) },
    review: { id: root.dataset.reviewVariantId, price: parseFloat(root.dataset.reviewPrice) },
    note: { id: root.dataset.noteVariantId, price: parseFloat(root.dataset.notePrice) }
  };

  function formatMoney(amount) {
    return amount.toFixed(2).replace('.', ',') + '€';
  }

  /* ---- Angel Number (3-digit, required) ---- */
  var angelInput = root.querySelector('[data-angel-number]');
  var angelCharcount = root.querySelector('[data-angel-charcount]');
  var angelPreviewWrap = root.querySelector('[data-angel-preview-wrap]');
  var angelPreview = root.querySelector('[data-angel-preview]');
  var angelFontGroup = root.querySelector('[data-pz-pills="angel-font"]');

  angelInput.addEventListener('input', function () {
    angelInput.value = angelInput.value.replace(/\D/g, '').slice(0, 3);
    angelCharcount.textContent = angelInput.value.length + '/3';
    angelPreview.textContent = angelInput.value;
    angelPreviewWrap.hidden = angelInput.value.length === 0;
  });

  angelFontGroup.addEventListener('click', function (e) {
    var btn = e.target.closest('.pz__pill');
    if (!btn) return;
    angelFontGroup.querySelectorAll('.pz__pill').forEach(function (p) { p.classList.remove('is-active'); });
    btn.classList.add('is-active');
    state.angelFont = btn.dataset.value;
    angelPreview.style.fontFamily = btn.style.fontFamily;
  });

  /* ---- Extra engraving (single text-only toggle, no photo option) ---- */
  var beToggle = root.querySelector('[data-be-toggle]');
  var beBody = root.querySelector('[data-be-simple-body]');
  var beText = root.querySelector('[data-be-text]');
  var beCharcount = root.querySelector('[data-be-charcount]');
  var beFontPreview = root.querySelector('[data-be-font-preview]');
  var beFontBtns = Array.prototype.slice.call(root.querySelectorAll('[data-be-font]'));

  beToggle.addEventListener('change', function () {
    state.extraEngrave = beToggle.checked;
    beBody.hidden = !state.extraEngrave;
    updateTotal();
  });

  beText.addEventListener('input', function () {
    beCharcount.textContent = beText.value.length + '/45';
    beFontPreview.textContent = wrapEvery15(beText.value.trim());
  });

  beFontBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      beFontBtns.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      state.extraFont = btn.dataset.beFont;
      beFontPreview.style.fontFamily = btn.style.fontFamily;
    });
  });

  var priorityToggle = root.querySelector('[data-pz-toggle="priority"]');
  priorityToggle.addEventListener('change', function () {
    state.priority = priorityToggle.checked;
    updateTotal();
  });

  var reviewToggle = root.querySelector('[data-pz-toggle="review"]');
  reviewToggle.addEventListener('change', function () {
    state.review = reviewToggle.checked;
    updateTotal();
  });

  var noteToggle = root.querySelector('[data-pz-toggle="note"]');
  noteToggle.addEventListener('change', function () {
    state.note = noteToggle.checked;
    updateTotal();
  });

  function updateTotal() {
    var total = state.basePrice;
    if (state.extraEngrave) total += addons.extraEngrave.price;
    if (state.priority) total += addons.priority.price;
    if (state.review) total += addons.review.price;
    if (state.note) total += addons.note.price;
    root.querySelector('[data-pz-total]').textContent = formatMoney(total);
  }

  var productForm = root.closest('form');
  if (productForm) {
    var variantInput = productForm.querySelector('input[name="id"], select[name="id"]');
    if (variantInput) {
      variantInput.addEventListener('change', function () {
        state.mainVariantId = variantInput.value;
        fetch(window.location.pathname + '.js')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var variant = data.variants.find(function (v) { return String(v.id) === String(state.mainVariantId); });
            if (variant) {
              state.basePrice = variant.price / 100;
              updateTotal();
            }
          });
      });
    }
  }

  var errorEl = root.querySelector('[data-pz-error]');
  var submitBtn = root.querySelector('[data-pz-submit]');

  function showError(msg) {
    errorEl.textContent = msg;
    errorEl.hidden = false;
  }

  submitBtn.addEventListener('click', function () {
    errorEl.hidden = true;
    var angelVal = angelInput.value.trim();
    if (!/^\d{3}$/.test(angelVal)) {
      showError('Γράψε τον Angel Number σου (3 ψηφία) πριν συνεχίσεις.');
      angelInput.focus();
      return;
    }
    var extraTextVal = beText.value.trim();
    if (state.extraEngrave && !extraTextVal) {
      showError('Γράψε το κείμενο για την επιπλέον χάραξη, ή απενεργοποίησε το διακόπτη.');
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = 'Προσθήκη...';

    var properties = {
      'Angel Number': angelVal,
      'Angel Number - Γραμματοσειρά': state.angelFont
    };
    if (state.extraEngrave) {
      properties['Επιπλέον Χάραξη - Κείμενο'] = extraTextVal;
      properties['Επιπλέον Χάραξη - Γραμματοσειρά'] = state.extraFont;
    }
    var notesVal = root.querySelector('[data-pz-field="notes"]').value.trim();
    if (notesVal) properties['Παρατηρήσεις - Σχόλια'] = notesVal;

    var items = [{ id: state.mainVariantId, quantity: 1, properties: properties }];
    if (state.extraEngrave) items.push({ id: addons.extraEngrave.id, quantity: 1 });
    if (state.priority) items.push({ id: addons.priority.id, quantity: 1 });
    if (state.review) items.push({ id: addons.review.id, quantity: 1 });
    if (state.note) items.push({ id: addons.note.id, quantity: 1 });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart-add-failed');
        return r.json();
      })
      .then(function () {
        window.location.href = '/cart';
      })
      .catch(function () {
        showError('Κάτι πήγε στραβά. Δοκίμασε ξανά.');
        submitBtn.disabled = false;
        submitBtn.textContent = 'Προσθήκη στο Καλάθι';
      });
  });

  updateTotal();
})();
